const searchToggle = document.querySelector('[data-toggle="header-search-form"]');
const searchForm = document.getElementById('header-search-form');

if(searchToggle && searchForm) {
    searchToggle.addEventListener('click', () => {
        searchForm.classList.toggle('active');

        if(searchForm.classList.contains('active')) {
            const searchInput = searchForm.querySelector('input[type="text"]');
            searchInput?.focus();
        }
    });
}